module.exports = __webpack_public_path__ + "static/media/img_package-classic.e08203fc.png";